import { ReactNode } from 'react';
import { Grid2, Typography } from '@mui/material';

export interface SettingsGridRowCell {
  id: string | number;
  text: string | ReactNode;
}

interface Props {
  cells: SettingsGridRowCell[];
}

function SettingsGridRow({ cells }: Props) {
  const columns = cells.length;
  return (
    <Grid2 container columns={columns} spacing={1} width="100%">
      {cells.map(cell => (
        <Grid2 size={1} key={cell.id}>
          <Typography variant="body2">{cell.text}</Typography>
        </Grid2>
      ))}
    </Grid2>
  );
}

export default SettingsGridRow;
